import {
    createRouter,
    createWebHistory
} from 'vue-router'

const router = createRouter({
    routes: [{
            path: '/',
            component: () =>
                import ('../pages/Auth/Login.vue'),
            meta: {
                guest: true,
            },
            name: 'login',
        }, {
            path: '/registration',
            component: () =>
                import ('../pages/Auth/Registration.vue'),
            meta: {
                guest: true,
            },
            name: 'registration',
        },
        // Login Pages
        {
            path: '/home',
            component: () =>
                import ('../pages/layouts/HomeLayout.vue'),
            meta: {
                // requiresAuth: true,
            },
            children: [{
                    path: '/home',
                    component: () =>
                        import ('../pages/Home.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'home'
                    },
                    name: 'home',
                },
                {
                    path: '/cars',
                    component: () =>
                        import ('../pages/CarsManagement/Cars.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'cars'
                    },
                    name: 'cars',
                },
                {
                    path: '/car/details/:id',
                    component: () =>
                        import ('../pages/CarsManagement/CarDetails.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'car'
                    },
                    name: 'car',
                },
                {
                    path: '/blogs',
                    component: () =>
                        import ('../pages/BlogsManagement/Blogs.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'blogs'
                    },
                    name: 'blogs',
                },
                {
                    path: '/blog/details/:id',
                    component: () =>
                        import ('../pages/BlogsManagement/BlogDetails.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'blog'
                    },
                    name: 'blog',
                },
                {
                    path: '/documents',
                    component: () =>
                        import ('../pages/DocumentExpireManagement/DocumentsList.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'documents'
                    },
                    name: 'documents',
                },
                {
                    path: '/document/form',
                    component: () =>
                        import ('../pages/DocumentExpireManagement/DocumentForm.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'documentForm'
                    },
                    name: 'document.form',
                },
                {
                    path: '/document/edit/:id',
                    component: () =>
                        import ('../pages/DocumentExpireManagement/DocumentForm.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'documentForm'
                    },
                    name: 'document.edit',
                },
                {
                    path: '/questions',
                    component: () =>
                        import ('../pages/ExamsManagement/Exam.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'questions'
                    },
                    name: 'questions',
                },
                {
                    path: '/videos',
                    component: () =>
                        import ('../pages/VideosManagement/videos.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'videos'
                    },
                    name: 'videos',
                },
                {
                    path: '/video/details/:id',
                    component: () =>
                        import ('../pages/VideosManagement/videoDetails.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'videoDetails'
                    },
                    name: 'video.details',
                },

                {
                    path: '/profile',
                    component: () =>
                        import ('../pages/profileManagement/myProfile.vue'),
                    meta: {
                        // requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'profile',
                },

            ]
        },
    ],
    history: createWebHistory(),
});


// router.beforeEach((to, from, next) => {
//     let userToken = localStorage.getItem('client/user-token');

//     if (to.matched.some(record => record.meta.requiresAuth)) {
//         let name = 'login';

//         if (userToken === null) {
//             next({
//                 name: name,
//                 params: { nextUrl: to.fullPath }
//             });
//         } else {
//             next();
//         }
//     } else if (to.matched.some(record => record.meta.guest)) {

//         if (userToken == null) {
//             next();
//         } else {
//             next({ name: 'home' });
//         }
//     } else {
//         next();
//     }
// });




export default router